<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 0C2.89543 0 2 0.895431 2 2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V7H8C7.44772 7 7 6.55228 7 6V0H4Z"
      fill="#3769D6"
    />
    <path
      opacity="0.5"
      d="M9 1.20711C9 0.761654 9.53857 0.538571 9.85355 0.853553L11.5 2.5L13.1464 4.14645C13.4614 4.46143 13.2383 5 12.7929 5H10C9.44772 5 9 4.55228 9 4V1.20711Z"
      fill="#3769D6"
    />
  </svg>
</template>
